import { FormControl, ValidationErrors } from '@angular/forms';
import moment, { Moment } from 'moment';

/**
 * All validators compare at day granularity. The control value is a `YYYY-MM-DD` string from a
 * native date input; parsing it with `new Date(...)` would yield UTC midnight and make the result
 * depend on the timezone and on the time of day.
 */
export class DateValidator {
    static DateAfterToday(control: FormControl): ValidationErrors | null {
        // If value is not set, it's possibly optional, return no error
        if (!control.value) return null;

        return moment(control.value).isAfter(moment(), 'day') ? null : { dateIsBeforeTomorrow: true };
    }

    static DateBeforeToday(control: FormControl): ValidationErrors | null {
        // If value is not set, it's possibly optional, return no error
        if (!control.value) return null;

        return moment(control.value).isBefore(moment(), 'day') ? null : { dateIsAfterYesterday: true };
    }

    static FirstOfAMonth(control: FormControl): ValidationErrors | null {
        // If value is not set, it's possibly optional, return no error
        if (!control.value) return null;

        return moment(control.value).date() === 1 ? null : { dateIsNotFirstOfMonth: true };
    }

    static MinDate =
        (date: Moment) =>
        (control: FormControl): ValidationErrors | null => {
            // If value is not set, it's possibly optional, return no error
            if (!control.value || !date) return null;

            return moment(control.value).isBefore(date, 'day') ? { dateIsBeforeMinDate: true } : null;
        };
}
